import { collection, doc, runTransaction, serverTimestamp } from "firebase/firestore";
const fingerprint = (data) => JSON.stringify([data.date, data.startTime, data.endTime, data.projectId, (data.employees || []).map((e) => [e.employeeId, e.name, e.isObemannad])]);

// Only reconcile passes created by this conversation; never recreate unrelated passes.
export async function persistVoiceFollowup(db, companyUid, schemaId, previous, payloads) {
  const remaining = [...previous];
  const next = payloads.map((data) => {
    let index = remaining.findIndex((item) => fingerprint(item.data) === fingerprint(data));
    if (index < 0) index = remaining.findIndex((item) => item.data.date === data.date && item.data.projectId === data.projectId);
    if (index < 0 && payloads.length === previous.length) index = 0;
    const old = index >= 0 ? remaining.splice(index, 1)[0] : null;
    return { ref: old ? doc(db, "users", companyUid, "shifts", old.id) : doc(collection(db, "users", companyUid, "shifts")), data, old };
  });
  await runTransaction(db, async (tx) => {
    const snapshots = await Promise.all(previous.map((item) => tx.get(doc(db, "users", companyUid, "shifts", item.id))));
    const current = new Map();
    snapshots.forEach((snapshot, index) => {
      const data = snapshot.data();
      if (!snapshot.exists() || data.schemaId !== schemaId || fingerprint(data) !== fingerprint(previous[index].data)) throw new Error("Passet har ändrats på annat håll. Öppna passet för att kontrollera det.");
      if (data.published || data.isBooked || (data.employees || []).some((e) => e.isBooked || e.isApproved || e.bookingId || e.absences?.length || e.overtime?.length || e.breaks?.length)) throw new Error("Passet har publicerats, bokats eller rapporterats. Ändra det i passredigeraren.");
      current.set(previous[index].id, data);
    });
    next.forEach(({ ref, data, old }) => {
      if (!old) tx.set(ref, data);
      else {
        const changes = Object.fromEntries(["date", "year", "month", "startTime", "endTime", "time", "project", "projectId", "employee", "employeeId", "isObemannad", "isSelfBookable", "bookingType"].map((key) => [key, data[key]]));
        const original = current.get(old.id);
        tx.update(ref, { ...changes, employees: data.employees.map((employee) => original.employees.find((e) => e.employeeId === employee.employeeId) || employee), updatedAt: serverTimestamp() });
      }
    });
    remaining.forEach((item) => tx.delete(doc(db, "users", companyUid, "shifts", item.id)));
  });
  return next.map(({ ref, data }) => ({ id: ref.id, data }));
}
